import { render, staticRenderFns } from "./ColumnSaleStatusInvoiceExpress.vue?vue&type=template&id=b332831e"
import script from "./ColumnSaleStatusInvoiceExpress.vue?vue&type=script&lang=js"
export * from "./ColumnSaleStatusInvoiceExpress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports